import icon from 'static/img/icons/home-icons/CECA_ICONOS_Hogar_14.svg';
import LandingSection from 'components/landing/components/landing-section';
import Spacer from 'core/spacer';
import Text from 'core/text';
import TextBox from 'core/text-box';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';

const InsuranceDescription = () => {
    const { seoText, verification } = useGetSeoTextByIndex('insurance_description');

    if (!verification) {
        return null;
    }

    const textBoxArray = useMemo(() => (
        Array.from({ length: 9 }, (_, i) => (
            <TextBox
                title={seoText[`item${i + 1}`].title}
                content={seoText[`item${i + 1}`].sentence1}
                image={icon}
                alignImage
                imageWidth={60}
                imageHeight={84}
                key={i + 1}
            />
        ))
    ), []);

    return (
        <LandingSection>
            <Title content={seoText.section_title} tag="h2" />
            <Text content={seoText.paragraph1.sentence1} />
            <Spacer space={4} />
            <div className="paragraph_wrapper_short">
                {textBoxArray}
            </div>
        </LandingSection>
    );
};

export default InsuranceDescription;
